import { View } from "@/components/ui";
import { CreditAccount } from "./credit-account";
import { MyVoucher } from "./my-voucher";

export const CreditOverview = () => {
  return (
    <View className="flex flex-row gap-4">
      <CreditAccount />
      <MyVoucher />
    </View>
  );
};
